<template>
  <Grid gtc="200px 1fr" class="finalize-licenses overflow-hidden">
    <template v-if="quickViewItems">
      <ModalSidebar ref="modalSidebar" item-type="name-period" :items="quickViewItems" @item-selected="openQuickView" />
      <Grid v-if="quickView" gtr="auto 1fr auto" class="overflow-hidden">
        <header class="bg-white-1 q-px-lg q-pt-md q-pb-sm shadow3">
          <div class="text-heading-1 text-secondary-2">{{ quickView.name }}</div>
        </header>

        <ModalBody>
          <Grid v-if="quickView" :key="quickView.id" gtc="1.5fr 1fr" gap="var(--r-space-sp)" align-items="start">
            <Grid gap="var(--r-space-md)">
              <TabTerms :data="quickView.terms" />
              <TabSummary :data="quickView.summary" />
              <Notes
                :entity="{ name: 'license-period', id: quickView.id }"
                :row-data="quickView.notes"
                store-namespace="license-periods"
              />
              <TabSubscriptions :data="quickView.subscriptions" />
            </Grid>

            <Grid gap="var(--r-space-md)">
              <LicenseFile :file="quickView.license_file" />

              <Attachments
                :entity="{ name: 'license-period', id: quickView.id }"
                :row-data="quickView.files"
                store-namespace="license-periods"
              />

              <Links
                :dropdown-initial-value="linksCategories"
                :entity="{ name: 'license-period', id: quickView.id }"
                :row-data="quickView.links"
                store-namespace="license-periods"
              />
            </Grid>
          </Grid>
        </ModalBody>

        <ModalFooter>
          <RBtn size="big" type="ghost" @click="process('dismissed')">dismiss</RBtn>
          <RBtn size="big" type="primary" @click="process('finalized')">Finalize</RBtn>
          <RBtn size="small" type="link" :to="`/licenses/${quickView.license.id}`">go to license</RBtn>
        </ModalFooter>
      </Grid>
    </template>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
import { linksCategories } from '@/reusable/data/links-categories'
import { createFormData } from '@/utils/create-form-data'
import { setSubtitle, getCount, getTaskData, checkQuickView, openQuickView } from '../modals-shared'
// Libraries
import { cloneDeep } from 'lodash'
// Components
import LicenseFile from '@/reusable/LicenseFile/LicenseFile'
import Attachments from '@components/lm-blocks/Attachments'
import Links from '@components/lm-blocks/Links'
import Notes from '@components/lm-blocks/Notes'
import { TabSummary, TabTerms, TabSubscriptions } from '@/reusable/license'
import ModalSidebar from '../components/ModalSidebar'
import ModalBody from '../components/ModalBody'
import ModalFooter from '../components/ModalFooter'

export default {
  components: {
    LicenseFile,
    Attachments,
    Links,
    Notes,
    TabSummary,
    TabTerms,
    TabSubscriptions,
    ModalSidebar,
    ModalBody,
    ModalFooter
  },

  props: {
    periodId: [Number, String]
  },

  data() {
    return {
      quickViewItems: null,
      quickView: null
    }
  },

  computed: {
    linksCategories
  },

  watch: {
    quickViewItems: 'setSubtitle'
  },

  created() {
    this.getTaskData('finalize-licenses').then(({ data }) => (this.quickViewItems = data.result))
  },

  methods: {
    getTaskData,
    getCount,
    checkQuickView,
    setSubtitle: setSubtitle('Licenses'),
    openQuickView: openQuickView('finalize-licenses', (vm, data, quickViewItem) => {
      vm.quickView = {
        ...data,
        publisher_id: quickViewItem.publisher?.id || null,
        license_id: quickViewItem.license_id
      }
    }),

    getPayload(status) {
      const data = cloneDeep(this.quickView)

      data.status = status
      data.owner_id = data.owner?.id || null

      delete data.license
      delete data.license_file

      const formData = new FormData()
      createFormData(formData, data)
      formData.append('_method', 'PUT')

      return formData
    },

    process(status) {
      this.$emit('set-loader', true)

      apiTo
        .FINALIZE_OR_DISMISS_LICENSE_PERIOD(this.quickView.id, this.getPayload(status))
        .then(this.checkQuickView)
        .finally(() => this.$emit('set-loader', false))
    }
  }
}
</script>

<style lang="scss" scoped>
.finalize-licenses {
  header {
    border-top: 1px solid var(--r-white-4);
    border-left: 1px solid var(--r-white-4);
    z-index: 1;
  }
}
</style>
